/**
 * Created by Caroline on 2019/11/25 0025.
 *
 */
import * as types from './types'

export default {
  [types.GET_ACTIVITY_ID](state, { payload }) {
    state.activityId = payload.id
    // console.log("GET_ACTIVITY_ID finished",);
  },
  [types.SET_ACTIVITY_ID](state, { payload }) {
    state.activityId = payload.id
  },
  [types.GET_LIVE_DETAIL](state, { payload }) {
    state.detail = payload.detail
  },
  [types.GET_SHARE_DATA](state, { payload }) {
    state.shareData = payload.shareData
  },

  [types.UPDATE_MODE](state, { payload }) {
    state.modeData = payload.modeData
    state.lottery = payload.modeData.lotteryConfig
    state.lotteryWinners = payload.modeData.lotteryConfig ? payload.modeData.lotteryConfig.recordList : []
  },
  [types.UPDATE_TAGS](state, { payload }) {
    state.tagIds = payload.tags.filter(item => item.show).map(item => item.id)
  },

  [types.GET_IMAGE_LIST](state, { payload }) {
    state.imageList = payload.imageList
  },

  [types.ADD_BLESSING](state, { payload }) {
    state.newBlessing = payload.newBlessing
  },
  [types.GET_BLESSING_LIST](state, { payload }) {
    const blessingList = [...payload.blessingList]
    state.blessingList = blessingList
    payload.blessingData ? state.blessingData = payload.blessingData : ''
    // console.log("GET_BLESSING_LIST", state.blessingList);
  },
  [types.UPDATE_BLESSING_LIST_BY_NEW](state, { payload }) {
    payload.newList.length && state.blessingList.splice(1, 0, ...payload.newList)
  },

  [types.UPDATE_LOTTERY](state, { payload }) {
    if (!state.lottery
      || (payload.lottery && payload.lottery.state)) {
      state.lottery = payload.lottery
      state.lotteryWinners = payload.lottery.recordList
    }
  },
  [types.GET_LOTTERY](state, { payload }) {
    state.lottery = payload.lottery
  },

  [types.UPDATE_WINDOW_SIZE](state, { payload }) {
    let win = {
      winWidth: payload.winWidth,
      winHeight: payload.winHeight,
      screenWScale: payload.winWidth < 1920 ? parseFloat((payload.winWidth / 1920 * 88 / 100).toFixed(2)) : 1,
      screenHScale: payload.winHeight < 1080 ? parseFloat((payload.winHeight / 1080 * 88 / 100).toFixed(2)) : 1,
    }
    state.win = win

    // console.log("UPDATE_WINDOW_SIZE", state.win);

    // if (!this.timer) {
    //   this.timer = true
    //   let that = this
    //   setTimeout(function (state) {
    //     let win = {
    //       winWidth: payload.winWidth,
    //       winHeight: payload.winHeight,
    //       screenWScale: payload.winWidth < 1920 ? parseFloat((payload.winWidth / 1920).toFixed(2)) : 1,
    //       screenHScale: payload.winHeight < 1080 ? parseFloat((payload.winHeight / 1080).toFixed(2)) : 1,
    //     }
    //     state.win = win
    //     console.log("UPDATE_WINDOW_SIZE", state.win);
    //     that.timer = false
    //   }, 400)
    // }

  },


  [types.SHOW_TOAST](state, { payload }) {
    state.toast = payload.toast
  },
  [types.HIDE_TOAST](state, { payload }) {
    state.toast = payload.toast
  },

  [types.UPDATE_GLOBAL_FONT](state, { payload }) {
    state.globalFont[payload.type] = payload.value
  },


}



// WEBPACK FOOTER //
// ./src/store/mutations.js